import Vue from 'vue';
import Glide from '@glidejs/glide';
import { gsap } from 'gsap';

Vue.component('carousel-component', {
    props: {
        slidesLength: {
            type: Number,
        }
    },
    data() {
        return {
            glide: null,
            sliderStart: true,
            sliderEnded: false,
        }
    },

    mounted() {

        if (document.querySelector('.glide--blocks') !== null) {
            this.initSlider();
        }

        EventBus.$on('window-resize', this.checkSlider);

    },

    methods: {
        initSlider() {
            this.glide = new Glide('.glide--blocks', {
                type: 'slider',
                startAt: 0,
                gap: 0,
                peek: 0,
                rewind: false,
                bound: true,
                perView: 3,
                animationTimingFunc: 'ease',
                animationDuration: 800,
                swipeThreshold: false,
                dragThreshold: false,

                breakpoints: {
                    2600: {
                        peek: { before: 0, after: 50 },
                        gap: 24,
                        perView: 4,
                        swipeThreshold: true,
                        dragThreshold: true,
                    },
                    1439: {
                        peek: { before: 0, after: 50 },
                        gap: 20,
                        perView: 3,
                        swipeThreshold: true,
                        dragThreshold: true,
                    },
                    1023: {
                        perView: 2,
                        peek: 0,
                        gap: 20,
                        swipeThreshold: true,
                        dragThreshold: true,
                    },
                    767: {
                        perView: 1,
                        peek: { before: 0, after: 50 },
                        gap: 20,
                    }
                }
            })

            this.glide.on('run.start', () => {
                this.sliderStart = true;
            })

            this.glide.on('run.end', () => {
                this.sliderEnded = true;
            })

            this.glide.on('run', (evt) => {
                if (evt.direction == '<') {
                    this.sliderEnded = false;
                } else if (evt.direction == '>') {
                    this.sliderStart = false;
                }
            })

            this.checkSlider();
        },

        nextSlide() {
            const slideMargin = document.querySelector('.carousel .glide__slide').style.marginRight;

            this.glide.go('>')

            if (this.sliderEnded) {
                return;
            }

            const elements = [...document.querySelectorAll('.glide__slide')];
            let passedActive = false;
            const result = [];

            for (let index = 0; index < elements.length; index++) {
                const element = elements[index];
                if (element.classList.contains('glide__slide--active')) {
                    passedActive = true;
                };
                if (passedActive) {
                    result.push(element);
                }
            }

            this.nextSlideTl = gsap.timeline({ paused: true });

            this.nextSlideTl.to(result, { marginRight: parseInt(slideMargin) * 4, duration: 0.2 });
            this.nextSlideTl.to(result, { marginRight: parseInt(slideMargin), duration: 0.4, stagger: 0.1, ease: "power2.out", delay: 0.2 }, 0.1);

            if (this.glide.settings.perView > 1) {
                this.nextSlideTl.play();
            }
        },

        previousSlide() {
            const slideMargin = document.querySelector('.carousel .glide__slide').style.marginRight;

            this.glide.go('<');

            // if (this.sliderStart) {
            //     return;
            // }

            // const elements = [...document.querySelectorAll('.glide__slide')];
            // const result = [];

            // const lastVisibleItemIndex = this.glide.settings.perView + this.glide.index;

            // for (let index = 0; index < elements.length; index++) {
            //     const element = elements[index];
            //     if (index <= lastVisibleItemIndex) {
            //         result.push(element);
            //     }
            // }

            // result.reverse();

            // this.prevSlideTl = gsap.timeline({ paused: true });

            // this.prevSlideTl.to(result, { marginLeft: parseInt(slideMargin) * 4, duration: 0.2 });
            // this.prevSlideTl.to(result, { marginLeft: parseInt(slideMargin), duration: 0.4, stagger: 0.1, ease: "power2.out", delay: 0.2 }, 0.1);

            // if (this.glide.settings.perView > 1) {
            //     this.prevSlideTl.play();
            // }
        },

        checkSlider() {
            this.glide.enable();
            if (window.innerWidth > 1439 && this.slidesLength < 5) {
                this.glide.disable();
            } else if (window.innerWidth > 1023 && this.slidesLength < 4) {
                this.glide.disable();
            } else if (window.innerWidth > 767 && this.slidesLength < 3) {
                this.glide.disable();
            } else if (window.innerWidth < 768 && this.slidesLength < 2) {
                this.glide.disable();
            }

            this.glide.update({ startAt: 0 });
            this.glide.mount();
        },

    },
});
